import React from "react";

const HeroSection = () => {
  return (
    <section
      className="relative w-full min-h-[480px] flex flex-col justify-center items-center text-center px-4 sm:px-6 md:px-12 lg:px-20"
      style={{
        background: "linear-gradient(180deg, #3B5CC9 0%, #1A1E2A 100%)",
      }}
    >
      <h1 className="text-white font-extrabold text-[40px] sm:text-[48px] md:text-[56px] leading-[1.1] max-w-[900px]">
        AI Education for <span className="text-[#ef912c]">Every Child</span>
      </h1>
      <p className="text-white text-[18px] sm:text-[20px] max-w-[700px] mt-4 font-normal leading-relaxed">
        Empowering underprivileged children with cutting-edge AI-powered education platform, making quality learning accessible to all.
      </p>
    </section>
  );
};

export default HeroSection;